import * as types from "../Action/type"
const initialState = {
    layoutColor:null,
    sideMenu:null,
}

const LayoutSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.COLORLAYOUT:
      return { ...state, layoutColor:action.payload }
    case types.COLORSIDEMENU:
        return { ...state, sideMenu:action.payload }
    default:
      return state;
  }


}
export default LayoutSettingReducer;
